<template>
  <div class="ward-icon-top-container" :class="{ retracted: !isExpanded }" @click="openStudentHome">
    <div class="app-icon-container">
      <img :src="logo" alt="EMN Logo" class="logo" />
    </div>
    <div class="divider" v-show="isExpanded"></div>
    <div class="ward-container" v-show="isExpanded">
      <h2 class="app-name">WARD</h2>
    </div>
  </div>
</template>

<script setup lang="ts">
import logoUrl from '@/assets/images/emn-logo-transparent.svg';
import { useRouter } from 'vue-router';
import { computed } from 'vue';

defineProps<{
  isExpanded?: boolean;
}>();

const router = useRouter();

const logo = computed(() => logoUrl);

const openStudentHome = () => {
  router.push({ name: 'Home' });
};
</script>

<style scoped>
.ward-icon-top-container {
  display: flex;
  align-items: center;
  border-radius: 0 0 24px 24px;
  opacity: 1;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
  cursor: pointer;
  position: sticky;
  top: 20px;
}

.ward-icon-top-container.retracted {
  justify-content: center;
}

.ward-icon-top-container.retracted .app-icon-container {
  width: 42px;
  height: 42px;
  margin-left: 0;
}

.ward-icon-top-container.retracted .app-icon-container::before {
  width: 42px;
  height: 42px;
}

.divider {
  width: 1px;
  height: 55px;
  background-color: var(--ion-color-primary);
  margin: 16px 8px 16px 8px;
  opacity: 0.6;
  flex-shrink: 0;
  transition: opacity 0.2s ease 0.1s;
}

.divider.fade-out {
  opacity: 0;
  transition: opacity 0.2s ease;
}

.ward-container {
  align-items: center;
  justify-content: center;
  /* flex: 1; */
  white-space: nowrap;
  transform: translateX(0);
  opacity: 1;
  transition:
    transform 0.3s cubic-bezier(0.4, 0, 0.2, 1),
    opacity 0.3s ease;
  overflow: hidden;
  background-color: transparent !important;
}

.app-icon-container {
  margin-left: 15px;
  width: 130px;
  height: 130px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.app-name {
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 1px;
  margin: 0;
  color: var(--ion-color-primary);
  text-align: center;
  font-family: var(--ion-font-family, inherit);
}

.logo {
  display: none;
}

.app-icon-container::before {
  content: '';
  display: block;
  width: 110px;
  height: 110px;
  background-color: var(--ion-color-primary);
  -webkit-mask: url('@/assets/images/emn-logo-transparent.svg') no-repeat center;
  -webkit-mask-size: contain;
  mask: url('@/assets/images/emn-logo-transparent.svg') no-repeat center;
  mask-size: contain;
}
</style>
